export const StorageUtility = {
  // Set a key-value pair in session storage
  setItem: (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error storing data:', error);
    }
  },

  // Get the value associated with a key from session storage
  getItem: (key) => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error retrieving data:', error);
      return null;
    }
  },

  // Remove the item associated with a key from session storage
  removeItem: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing data:', error);
    }
  },

  // Clear all data stored in session storage
  clear: () => {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error('Error clearing data:', error);
    }
  },
};

// Example usage:
// StorageUtility.setItem('user', { name: 'John', age: 30 });
// const user = StorageUtility.getItem('user');
// console.log(user); // ==> Output: { name: 'John', age: 30 }

// StorageUtility.removeItem('user');
// console.log(StorageUtility.getItem('user')); // ==> Output: null
